import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "../../../component/atoms/input/mainInput";
import ImgPreviewLarge from "../../../component/molecules/imgPreviewLarge";
import ImgInputLarge from "../../../component/atoms/input/imgInputLarge";
import Checkbox from "../../../component/atoms/input/checkbox";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import PopupOverLay from "../../../component/templates/PopupOverlay";
import Popup from "../../../component/molecules/popup";
import SearchBar from "../../../component/atoms/input/searchBar";
import BasicBtn from "../../../component/atoms/button/basicBtn";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";

import FileApi from "../../../api/file.api";
import CurriculumApi from "../../../api/curriculum.api";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import { fileUrl } from "../../../api/api";
import { route } from "../../../router/route";
import RelatedProductsPopup from "../../../component/templates/modal/relatedProductsPopup";

const KnowledgeCurriculumEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.knowledge_curriculum)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const categoryList = [
    { title: "고속부스트", value: "BOOST" },
    { title: "기초반", value: "BEGINNER" },
    { title: "중급반", value: "INTERMEDIATE" },
    { title: "고급반", value: "ADVANCED" },
    { title: "마스터", value: "MASTER" },
    { title: "코칭·특강·자문", value: "COACHING" },
    { title: "네트워킹", value: "NETWORKING" },
  ];

  // 메인 카테고리
  const [mainCategoryBoxOpen, setMainCategoryBoxOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [title, setTitle] = useState("");
  const [intro, setIntro] = useState("");
  const [upcoming, setUpcoming] = useState(false);
  const [link, setLink] = useState("");
  const [merchIdList, setMerchIdList] = useState([]);

  // ---------- 이미지 관련 --------- //
  const [image, setImage] = useState({
    file: "",
    fileUrl: "",
    fileName: "",
  });

  useEffect(() => {
    getVuInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getVuInfo = async () => {
    try {
      const response = (await CurriculumApi.getById(id)).data.data.content;

      setTitle(response.title);
      setIntro(response.intro);
      setLink(response.link);

      if (response.link) {
        const number = response.link.split("/").pop(); // 마지막 부분 추출
        setMerchIdList([{ id: Number(number) }]);
      }

      setUpcoming(response.upcoming);
      setSelectedCategory(response.curriculumType);
      setImage({
        ...image,
        imageOriginFileName: response.imageOriginFileName,
        imageServerFileName: response.imageServerFileName,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const inputFile = (e) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = (value) => {
      setImage({
        imageOriginFileName: null,
        imageServerFileName: null,
        file: file,
        fileUrl: value.target.result,
        fileName: file.name,
      });
    };

    e.target.value = "";
  };

  const deleteFile = () => {
    setImage({
      ...image,
      file: null,
      fileUrl: null,
      fileName: null,
      imageOriginFileName: null,
      imageServerFileName: null,
    });
  };

  const [popupOpen, setPopupOpen] = useState(false);

  const editFunc = async () => {
    try {
      if (selectedCategory === "") {
        return toast("카테고리를 선택해주세요.");
      }

      if (title === "") {
        return toast("제목을 입력해주세요.");
      }

      if (intro === "") {
        return toast("상품 소개를 입력해주세요.");
      }

      if (image.imageServerFileName === null && image.fileUrl === null) {
        return toast("이미지를 등록해주세요.");
      }

      // if (link === "") {
      //   return toast("상품 URL을 입력해주세요.");
      // }

      const data = {
        title: title,
        intro: intro,
        link: link,
        upcoming: upcoming,
        curriculumType: selectedCategory,
      };

      if (image.fileUrl) {
        const pcImageResponse = await FileApi.fileUpload(
          image.file,
          "admin/curriculum"
        );

        data.imageOriginFileName = pcImageResponse.data.data.originalFileName;
        data.imageServerFileName = pcImageResponse.data.data.serverFileName;
      } else {
        data.imageOriginFileName = image.imageOriginFileName;
        data.imageServerFileName = image.imageServerFileName;
      }

      await CurriculumApi.update(id, data);

      toast(toastMsg.create);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>커리큘럼 상품 편집 및 추가</TableTitle>
          {/* 카테고리 영역 */}
          <CurriculumInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <CurriculumInputTitle>카테고리</CurriculumInputTitle>

            <SelectBoxValue
              placeholder="카테고리를 선택해주세요"
              selectedValue={selectedCategory}
              isOpen={mainCategoryBoxOpen}
              wrapperHandler={() => {
                setMainCategoryBoxOpen(!mainCategoryBoxOpen);
              }}
              itemList={categoryList}
              selectedValueSetterFunc={setSelectedCategory}
            />
          </CurriculumInputWrapper>

          {/* 상품명 영역 */}
          <CurriculumInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <CurriculumInputTitle>상품명</CurriculumInputTitle>
            <MainInput
              type={"text"}
              placeholder={"상품명을 입력해 주세요."}
              style={{ width: "572px" }}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </CurriculumInputWrapper>

          {/* 상품 소개 영역 */}
          <CurriculumInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <CurriculumInputTitle>상품 소개</CurriculumInputTitle>
            <MainInput
              type={"text"}
              placeholder={"상품 소개 (28자 이내)"}
              style={{ width: "572px" }}
              value={intro}
              onChange={(e) => {
                setIntro(e.target.value);
              }}
              maxLength={28}
            />
          </CurriculumInputWrapper>

          {/* 이미지 영역 */}
          <CurriculumInputWrapper
            style={{
              padding: "21px 0px",
              alignItems: "flex-start",
            }}
          >
            <CurriculumInputTitle>이미지</CurriculumInputTitle>
            {image.fileUrl || image.imageServerFileName ? (
              <ImgPreviewLarge
                fileUrl={
                  image.fileUrl
                    ? image.fileUrl
                    : `${fileUrl}/${image.imageServerFileName}`
                }
                onClick={() => {
                  deleteFile();
                }}
              />
            ) : (
              <ImgInputLarge
                id={"file"}
                accept={"image/*"}
                onChange={(e) => {
                  inputFile(e);
                }}
              />
            )}
          </CurriculumInputWrapper>

          {/* 상품 옵션 영역 */}
          <CurriculumInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <CurriculumInputTitle>상품 옵션</CurriculumInputTitle>
            <CheckboxWrapper
              onClick={() => {
                setUpcoming(!upcoming);
              }}
            >
              <Checkbox
                style={{
                  backgroundColor: "transparent",
                }}
                checked={upcoming}
                onChange={() => {
                  setUpcoming(!upcoming);
                }}
              />
              <CheckboxText>오픈 예정</CheckboxText>
            </CheckboxWrapper>
          </CurriculumInputWrapper>

          {/* 상품 URL 영역 */}
          <CurriculumInputWrapper
            style={{
              padding: "21px 0px",
              alignItems: "flex-start",
            }}
          >
            <CurriculumInputTitle>상품 URL</CurriculumInputTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <MainInput
                type={"text"}
                placeholder={"상품 URL을 입력"}
                style={{ width: "572px" }}
                value={link}
                onChange={(e) => {
                  setLink(e.target.value);
                }}
              />

              <GrayBtn
                onClick={() => {
                  setPopupOpen(true);
                }}
              >
                지식상점 상품 연결
              </GrayBtn>
            </div>
          </CurriculumInputWrapper>
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            {isWriteAuthority && (
              <BasicBtn
                onClick={() => {
                  editFunc();
                }}
              >
                수정하기
              </BasicBtn>
            )}
          </div>
        </DetailPageLayout>
      </MainLayout>

      {/* 지정 상품 추가 팝업 */}
      {popupOpen && (
        <RelatedProductsPopup
          setPopupOpen={setPopupOpen}
          setValue={setMerchIdList}
          value={merchIdList}
          setLink={setLink}
        />
      )}
    </>
  );
};

export default KnowledgeCurriculumEdit;

const CurriculumInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const CurriculumInputTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
